    <!-- Additional Controls Section (Layer Manager, Vertical, Infrared) -->
    <div class="map-controller-container">
        <!-- Layer Manager (Left) -->
        <app-layer-manager-widget
                [collectionLayer]="viewerService.collectionLayers$ | async"
                [overlayLayers]="viewerService.overlayLayers$ | async"
                [dualViewEnabled]="false"
                [aois]="(viewerService.projectStatus$ | async)?.enabledAOIs"
                [isActivatedAutoContrast]="viewerService.enableContrast$ | async"
                [centerAOI]="(viewerService.projectStatus$ | async)?.centerAOI"></app-layer-manager-widget>

        <button
                matMiniFab
                *ngIf="is3D && enableNadirButton()"
                matTooltip="View vertical images"
                type="button"
                [class.selected]="orientation === 'N*'"
                (click)="loadNadirImage()">
            V
        </button>

        <app-infrared-selector
                *ngIf="(flagService.getFlags$() | async)?.[FeatureFlags.INFRARED] && !viewerService.is3DMode()"
                [active]="viewerService.infraredStatus$ | async"
                [activeTrigger]="viewerService.infraredTrigger$ | async"
                [enabled]="enableInfraredButton"
                matTooltip="{{ enableInfraredButton ? '' : 'Vertical CIR imagery not available' }}"></app-infrared-selector>
        <button
                matMiniFab
                *ngIf="(flagService.getFlags$() | async)?.[FeatureFlags.INFRARED] && showInfraredButton3D"
                matTooltip="{{ enableInfraredButton ? 'Vertical CIR imagery' : 'Vertical CIR imagery not available' }}"
                [class.disabled]="!enableInfraredButton"
                type="button"
                class="infrared-button"
                [class.selected]="orientation === 'I'"
                (click)="loadInfraredImage()">
            CIR
        </button>


        <div matTooltip="Zoom In">
            <button matMiniFab id="zoom-in-button" type="button" (click)="zoomIn()" [disabled]="lockZoomIn">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <div matTooltip="Zoom Out">
            <button matMiniFab id="zoom-out-button" type="button" (click)="zoomOut()" [disabled]="lockZoomOut">
                <mat-icon>remove</mat-icon>
            </button>
        </div>
        <!-- Compass Controller Section (with integrated 2D/3D toggle and tooltips) -->
        <app-compass-controller
                [compassRotation]="controllerRotation"
                [textRotation]="textRotation"
                [selectedOrientation]="orientation"
                [is3DMode]="is3D"
                [mode3DTooltip]="get3DModeMessage()"
                [enable3DButton]="enable3DButton()"
                [orientationTooltips]="getOrientationTooltips()"
                [availableOrientations]="getAvailableOrientations()"
                (orientationChange)="changeOrientation($event)"
                (modeToggle)="changeMode()"></app-compass-controller>


        <!-- Loading Progress Bar (always reserves space) -->
        <div class="progress-bar-container">
            <mat-progress-bar *ngIf="showLoading" mode="indeterminate" color="primary"></mat-progress-bar>
        </div>
    </div>

